
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Generale',
	'widgetId': 'ID Widget',
	'widgetType': 'Tipo di widget',
	'serviceability': 'Funzionalità',
	'copyButton': 'Copia',
	'closeButton': 'Chiudi',
	'specification': 'Specifica',
	'viewSpecification': 'Specifica della vista'
});
